/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { AbstractRestService, RestSettings } from '@gh/core-data';

import { Observable } from 'rxjs';
import { ImportLeadsBatchIdDto, ImportLeadsTemplateDto } from './import-leads.dto';
import {
  ImportLeadsBatchIdMapper,
  ImportLeadsFileMapper,
  ImportLeadsTemplateMapper,
} from './import-leads.mapper';
import { ImportPriceBatchIdMapper } from '../import-price-items';

@Injectable()
export class ImportLeadsRestService extends AbstractRestService {

  constructor(settings: RestSettings) {
    super(settings);
  }

  getBatchId(file: File, isHistorical: boolean): Observable<ImportLeadsBatchIdDto> {
    return this.httpPost(`${this.bp}/leads/import?isHistorical=${isHistorical}`, file, ImportLeadsFileMapper, ImportLeadsBatchIdMapper);
  }

  getGoogleBatchId(id: string, isHistorical: boolean): Observable<ImportLeadsBatchIdDto> {
    return this.httpGet(`${this.crm}/leads/import-from-google?spreadsheetId=${id}&isHistorical=${isHistorical}`,
                        void 0, void 0, ImportPriceBatchIdMapper);
  }

  getExcelTemplate(): Observable<ImportLeadsTemplateDto> {
    return this.httpGet(`${this.crm}/leads/import/template`, ImportLeadsTemplateMapper);
  }

  getGoogleSheetTemplate(): Observable<ImportLeadsTemplateDto> {
    return this.httpGet(`${this.crm}/leads/import/generate-template`, ImportLeadsTemplateMapper);
  }
}
